import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';

/**
 * The Colored Background component renders a div with a specific colored background.
 *
 */
import { jsx as _jsx } from "react/jsx-runtime";
function ColoredBackground(_ref) {
  let {
    children,
    className,
    inset = false,
    uiContext = 'default',
    invertText,
    ...rest
  } = _ref;
  let backGroundColor = '';
  switch (uiContext) {
    // example of mapping context to background color class
    case 'accent':
      backGroundColor = 'bg-accent';
      invertText = invertText ?? true;
      break;
    case 'inverted':
      backGroundColor = 'bg-primary';
      invertText = invertText ?? true;
      break;
    case 'transparent':
      backGroundColor = 'bg-dark-transparent-85';
      invertText = invertText ?? true;
      break;
    case 'info':
      backGroundColor = 'bg-info';
      break;
    case 'banner':
      backGroundColor = 'bg-gray-dark';
      invertText = invertText ?? true;
      break;
    case 'dark':
      backGroundColor = 'bg-neutral-inverse-primary';
      invertText = invertText ?? true;
      break;
    case 'dark-gray':
      backGroundColor = 'bg-gray-base';
      break;
    case 'lighter-gray':
      backGroundColor = 'bg-neutral-tertiary';
      break;
    case 'light-gray':
      backGroundColor = 'bg-gray-light';
      break;
    case 'dark-blue':
      backGroundColor = 'bg-blue-darkest';
      invertText = invertText ?? true;
      break;
    case 'success':
      backGroundColor = 'bg-success';
      break;
    case 'white':
      backGroundColor = 'bg-neutral-primary';
      break;
    default:
      backGroundColor = 'bg-neutral-secondary';
  }
  const rootClassName = clsx({
    'colored-background': true,
    inverted: invertText,
    inset,
    [backGroundColor]: true
  }, className);
  return /*#__PURE__*/_jsx("div", {
    "data-cmp": "coloredBackground",
    className: rootClassName,
    ...rest,
    children: children
  });
}
export default ColoredBackground;